import { Box, Group, Stack, Text } from "@mantine/core";
import { useDroppable } from "@dnd-kit/core";
import { useTranslation } from "react-i18next";

import OrderByChip from "../OrderByChip/OrderByChip";
import { useDeleteOrderByMutation } from "../../hooks/mutations";
import {
  DROP_ORDER_BY_TARGET,
  orderByTargetId,
} from "../../dnd/kinds";
import classes from "./OrderBy.module.scss";

/**
 * The "Order By" section. Drop an entity-field to append it
 * (postOrderBy). Each chip exposes an ASC/DESC toggle and a delete X.
 *
 * NOTE: As with the other drop targets, the legacy per-chip
 * DataFieldFunctions popover is deferred to a follow-up.
 */
export default function OrderBy({
  ruleId,
  queryId,
  orderByData,
  canEdit = true,
}) {
  const { t } = useTranslation();
  const { mutate: deleteOrderBy } = useDeleteOrderByMutation({ ruleId });

  const { setNodeRef, isOver } = useDroppable({
    id: orderByTargetId(queryId),
    data: { kind: DROP_ORDER_BY_TARGET, queryId },
  });

  return (
    <Stack gap={4}>
      <Text size="sm" fw={600}>
        {t("dataFields.orderBy")}
      </Text>
      <Box
        ref={setNodeRef}
        className={`${classes.wrapper} ${isOver ? classes.over : ""}`}
      >
        {!orderByData?.length ? (
          <Text size="sm" c="dimmed" ta="center" py="sm">
            {t("dataFields.dropDataField")}
          </Text>
        ) : (
          <Group gap={6} className={classes.list}>
            {orderByData.map((item, i) => (
              <OrderByChip
                key={item.id}
                ruleId={ruleId}
                queryId={queryId}
                id={item.id}
                entityField={item.entityField}
                sortType={item.sortType}
                index={i}
                canEdit={canEdit}
                onDelete={() => deleteOrderBy(item.id)}
              />
            ))}
          </Group>
        )}
      </Box>
    </Stack>
  );
}
